import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock",
  "use": "clock-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"clock\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 8a7 7 0 1014 0A7 7 0 001 8zm13 0A6 6 0 112 8a6 6 0 0112 0z\" /><path d=\"M8 4H7v5h4.004l.029-1H8V4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol